import { render, staticRenderFns } from "./PlaceholderScreen.vue?vue&type=template&id=416059bc&scoped=true&"
import script from "./PlaceholderScreen.vue?vue&type=script&lang=js&"
export * from "./PlaceholderScreen.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderScreen.vue?vue&type=style&index=0&id=416059bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416059bc",
  null
  
)

component.options.__file = "PlaceholderScreen.vue"
export default component.exports